import { Button } from '@habitech/call-to-action';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { InfoUser, Wrapper, WrapperIcon } from '../styles';
import { useSuggestedForm } from './suggested.hook';
import { GridContainer, GridItem } from 'src/components/common/grids';
import { selectDataSuggested } from 'src/redux/shopping_cart/shopping_cart.selectors';
import { useAppSelector } from 'src/hooks/redux';
import { WrapperButton } from './suggested-form.styles';
import Icon from 'src/components/common/Icon';


const SuggestedForm = () => {
    const { handleChange, handleSubmit, isValid, errors } = useSuggestedForm();
    const {loading, errorMessage, suggested} = useAppSelector(selectDataSuggested);

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (isValid) handleSubmit();
    };

    return (
        <Wrapper>
            <form onSubmit={onSubmit} noValidate>
            <GridContainer>
                <GridItem lg={10}>
                    <WrapperIcon>
                        <Icon icon="pcom-icon-user" size={18} />
                        Buscar del cliente
                    </WrapperIcon>
                    <TextField
                        originType="pcom"
                        name="email"
                        dataId="testing_text_field"
                        defaultValue={''}
                        placeHolder="Ingrese correo electrónico"
                        onChange={handleChange.bind(null)}
                        error={errors["email"] || errorMessage}
                        errorMessage={errors["email"] || errorMessage}
                    />
                </GridItem>
                <GridItem lg={2}>
                    <WrapperButton>
                        <Button
                            size='large'
                            disabled={!isValid}
                            dataId={'button-send-suggestions'}
                            originType="pcom"
                            variant="primary"
                            loading={loading}
                            type="submit"
                        >
                            Buscar
                        </Button>
                    </WrapperButton>
                </GridItem>
                {
                    suggested.users.email !== "" &&
                    <GridItem lg={12}>
                        <InfoUser>
                            <div className="item-user-info" data-poc={suggested.user_profile?.freemium_state !== null}>
                                POC Premium: {suggested.user_profile?.freemium_state !== null ? 'Sí' : 'No'}
                            </div>
                            <div className="item-user-info">
                                #id: {suggested.users.user_id}
                            </div>
                            {suggested.user_profile?.name && (
                                <div className="item-user-info">
                                    Nombre:{suggested.user_profile.name} {suggested.user_profile.lastname}
                                </div>
                            )}
                            <div className="item-user-info">
                                <Icon icon="pcom-icon-user" size={18} /> {suggested.users.email}
                            </div>
                            {suggested.user_profile?.contact_phone?.phone && (
                                <div className="item-user-info">
                                    Tel: {suggested.user_profile.contact_phone.phone}
                                </div>
                            )}
                            {suggested.user_profile?.broker_type && (
                                <div className="item-user-info">
                                    Tipo broker: {suggested.user_profile.broker_type}
                                </div>
                            )}
                            <div className="item-user-info">
                                Propiedades activas: {suggested.user_profile?.active_properties ?? 0}
                            </div>
                            <div className="item-user-info">
                                Propiedades destacadas: {suggested.user_profile?.highlighted_properties ?? 0}
                            </div>
                            <div className="item-user-info">
                                Slots utilizados: {suggested.user_profile?.total_active_slots ?? 0}
                            </div>
                            
                        </InfoUser>
                    </GridItem>
                }
            </GridContainer>
            </form>
        </Wrapper>
    );
};
export default SuggestedForm;
